import { graphql } from '@e-socna/data-layer';

export const DocumentTemplatePage_DocumentTemplateVersions_QueryDocument =
  graphql(`
    query DocumentTemplatePage_DocumentTemplateVersions_Query(
      $originalId: Id!
    ) {
      findAllEditableVersionsForOneOriginalId: findAllDocumentTemplateVersionsForOneOriginalId(
        originalId: $originalId
      ) {
        _id
        createdAt
        creatorId
        automaticMemo
        internalMemo
        memo
        version {
          _id
          creatorId
          updaterId
          createdAt
          updatedAt
          label
          statusId

          document {
            _id
            creatorId
            updaterId
            createdAt
            updatedAt
            contentUpdatedAt

            title
            templateId
            typeId
            kind

            code
            codingConfig {
              _id
              kind
              strategyId
              ... on CodingConfigManual {
                code
              }
            }

            virtualRoot {
              _id
              template {
                _id
                type
              }
              contentOriginId
              isVirtual
              hasPagebreakBefore
              hasPagebreakAfter
              title
              content
              orientation
              paperFormat
              isInsertionPoint
              customLayouts {
                _id
                sectionId
                orientation
                paperFormat
                hasPagebreakAfter
                hasPagebreakBefore
              }
              displayCondition {
                mode
                resolverId
                value
              }

              subSections {
                _id
                template {
                  _id
                  type
                }
                contentOriginId
                isVirtual
                hasPagebreakBefore
                hasPagebreakAfter
                title
                content
                orientation
                paperFormat
                isInsertionPoint
                customLayouts {
                  _id
                  sectionId
                  orientation
                  paperFormat
                  hasPagebreakAfter
                  hasPagebreakBefore
                }
                displayCondition {
                  mode
                  resolverId
                  value
                }

                subSections {
                  _id
                  template {
                    _id
                    type
                  }
                  contentOriginId
                  isVirtual
                  hasPagebreakBefore
                  hasPagebreakAfter
                  title
                  content
                  orientation
                  paperFormat
                  isInsertionPoint
                  customLayouts {
                    _id
                    sectionId
                    orientation
                    paperFormat
                    hasPagebreakAfter
                    hasPagebreakBefore
                  }
                  displayCondition {
                    mode
                    resolverId
                    value
                  }

                  subSections {
                    _id
                    template {
                      _id
                      type
                    }
                    contentOriginId
                    isVirtual
                    hasPagebreakBefore
                    hasPagebreakAfter
                    title
                    content
                    orientation
                    paperFormat
                    isInsertionPoint
                    customLayouts {
                      _id
                      sectionId
                      orientation
                      paperFormat
                      hasPagebreakAfter
                      hasPagebreakBefore
                    }
                    displayCondition {
                      mode
                      resolverId
                      value
                    }

                    subSections {
                      _id
                      template {
                        _id
                        type
                      }
                      contentOriginId
                      isVirtual
                      hasPagebreakBefore
                      hasPagebreakAfter
                      title
                      content
                      orientation
                      paperFormat
                      isInsertionPoint
                      customLayouts {
                        _id
                        sectionId
                        orientation
                        paperFormat
                        hasPagebreakAfter
                        hasPagebreakBefore
                      }
                      displayCondition {
                        mode
                        resolverId
                        value
                      }

                      subSections {
                        _id
                        template {
                          _id
                          type
                        }
                        contentOriginId
                        isVirtual
                        hasPagebreakBefore
                        hasPagebreakAfter
                        title
                        content
                        orientation
                        paperFormat
                        isInsertionPoint
                        customLayouts {
                          _id
                          sectionId
                          orientation
                          paperFormat
                          hasPagebreakAfter
                          hasPagebreakBefore
                        }
                        displayCondition {
                          mode
                          resolverId
                          value
                        }

                        subSections {
                          _id
                          template {
                            _id
                            type
                          }
                          contentOriginId
                          isVirtual
                          hasPagebreakBefore
                          hasPagebreakAfter
                          title
                          content
                          orientation
                          paperFormat
                          isInsertionPoint
                          customLayouts {
                            _id
                            sectionId
                            orientation
                            paperFormat
                            hasPagebreakAfter
                            hasPagebreakBefore
                          }
                          displayCondition {
                            mode
                            resolverId
                            value
                          }

                          subSections {
                            _id
                            template {
                              _id
                              type
                            }
                            contentOriginId
                            isVirtual
                            hasPagebreakBefore
                            hasPagebreakAfter
                            title
                            content
                            orientation
                            paperFormat
                            isInsertionPoint
                            customLayouts {
                              _id
                              sectionId
                              orientation
                              paperFormat
                              hasPagebreakAfter
                              hasPagebreakBefore
                            }
                            displayCondition {
                              mode
                              resolverId
                              value
                            }

                            subSections {
                              _id
                              template {
                                _id
                                type
                              }
                              contentOriginId
                              isVirtual
                              hasPagebreakBefore
                              hasPagebreakAfter
                              title
                              content
                              orientation
                              paperFormat
                              isInsertionPoint
                              customLayouts {
                                _id
                                sectionId
                                orientation
                                paperFormat
                                hasPagebreakAfter
                                hasPagebreakBefore
                              }
                              displayCondition {
                                mode
                                resolverId
                                value
                              }

                              subSections {
                                _id
                                template {
                                  _id
                                  type
                                }
                                contentOriginId
                                isVirtual
                                hasPagebreakBefore
                                hasPagebreakAfter
                                title
                                content
                                orientation
                                paperFormat
                                isInsertionPoint
                                customLayouts {
                                  _id
                                  sectionId
                                  orientation
                                  paperFormat
                                  hasPagebreakAfter
                                  hasPagebreakBefore
                                }
                                displayCondition {
                                  mode
                                  resolverId
                                  value
                                }

                                subSections {
                                  _id
                                  template {
                                    _id
                                    type
                                  }
                                  contentOriginId
                                  isVirtual
                                  hasPagebreakBefore
                                  hasPagebreakAfter
                                  title
                                  content
                                  orientation
                                  paperFormat
                                  isInsertionPoint
                                  customLayouts {
                                    _id
                                    sectionId
                                    orientation
                                    paperFormat
                                    hasPagebreakAfter
                                    hasPagebreakBefore
                                  }
                                  displayCondition {
                                    mode
                                    resolverId
                                    value
                                  }

                                  subSections {
                                    _id
                                    template {
                                      _id
                                      type
                                    }
                                    contentOriginId
                                    isVirtual
                                    hasPagebreakBefore
                                    hasPagebreakAfter
                                    title
                                    content
                                    orientation
                                    paperFormat
                                    isInsertionPoint
                                    customLayouts {
                                      _id
                                      sectionId
                                      orientation
                                      paperFormat
                                      hasPagebreakAfter
                                      hasPagebreakBefore
                                    }
                                    displayCondition {
                                      mode
                                      resolverId
                                      value
                                    }

                                    subSections {
                                      _id
                                      template {
                                        _id
                                        type
                                      }
                                      contentOriginId
                                      isVirtual
                                      hasPagebreakBefore
                                      hasPagebreakAfter
                                      title
                                      content
                                      orientation
                                      paperFormat
                                      isInsertionPoint
                                      customLayouts {
                                        _id
                                        sectionId
                                        orientation
                                        paperFormat
                                        hasPagebreakAfter
                                        hasPagebreakBefore
                                      }
                                      displayCondition {
                                        mode
                                        resolverId
                                        value
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }

          # pdfPrints {
          #   _id
          #   increment
          #   fileId
          #   settings {
          #     _id
          #     addHeaders
          #     addFooters
          #     printStyleId
          #   }
          #   isTmp

          #   createdAt
          #   creatorId
          #   updatedAt
          #   updaterId

          #   automaticMemo
          #   internalMemo
          #   memo
          # }
          # pdfPrintsIncrement

          code
          codingConfig {
            _id
            kind
            strategyId
            ... on CodingConfigManual {
              code
            }
          }
        }
      }
    }
  `);
